exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".non-resizeable[data-v-ea247c96] {\n  resize: none;\n}\n", ""]);

// exports
